export const chart = () => ({
    padding: '32px',
});

export const extendCardLoader = {
    background: () => ({
        height: '74%',
    }),
};
